module.exports = __webpack_public_path__ + "media/components/assets/icons/sns_no-1e7ec25d959ac94071f2b8cefd897bba.svg";